// removed by extract-text-webpack-plugin
module.exports = {"receipt-info-box":"app-components-receipt-invoices-InfoBox-__InfoBox___37O8V","receipt-date":"app-components-receipt-invoices-InfoBox-__InfoBox___1mQLF","receipt-number":"app-components-receipt-invoices-InfoBox-__InfoBox___3WHHx","receipt-served":"app-components-receipt-invoices-InfoBox-__InfoBox___1rkqk","receipt-collected":"app-components-receipt-invoices-InfoBox-__InfoBox___zieBV","payment-due-invoice":"app-components-receipt-invoices-InfoBox-__InfoBox___1T3dn","payment-due-invoice-black":"app-components-receipt-invoices-InfoBox-__InfoBox___pv3eT"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/invoices/InfoBox/InfoBox.css
// module id = 751
// module chunks = 0